import $ from "jquery";
import Isotope from "isotope-layout";
import 'isotope-packery';
// npm install isotope-layout
// npm install isotope-packery
import { setIntervalTimes } from "./utils.js";

$(function() {
    $(".bl-bloglist").each(function() {
        const $bl = $(this);

        //Init isotope
        const $guttersizer = $bl.find(".guttersizer");
        const $columnsizer = $bl.find(".columnsizer");

        const iso = new Isotope(".bl-bloglist .ctritems", {
            layoutMode: 'packery',
            itemSelector: ".item",
            percentPosition: true,
            packery: {
                gutter: $guttersizer.get(0),
                columnWidth: $columnsizer.get(0)
            }
        });

        $(window).on("load", function() {
            iso.layout();
        });
    });
});